import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Divider } from '@material-ui/core';
import Tooltip from '../Tooltip';
import useStyles from '../Tooltip.style';
import Member from '../../member/Member';
import { TeamMember } from '../../../models/pages/tournament/playoff/publication/PublishedTournament';
import PartnerFields from '../../../models/pages/team/PartnerFields';

function Participants(props: {
  children: JSX.Element
  teamMembers: TeamMember[] | PartnerFields[]
}) {
  const { children, teamMembers } = props;
  const classes = useStyles();
  return (
    <Tooltip
      index={uuidv4()}
      content={(
        <div className={classes.wrapper}>
          {teamMembers?.map((member, index) => (
            <div
              key={uuidv4()}
              className={classes.member}
            >
              <Member profilePicture={member.profilePicture} fullName={member.name} />
              {index !== Number(teamMembers?.length) - 1 && <Divider className={classes.divider} />}
            </div>
          ))}
        </div>
      )}
      container={React.cloneElement(children)}
    />
  );
}

export default Participants;